import * as types from './mutations-type.js';
const mutations = {
  [types.SET_TITLE] (state, payload) {
    state.title = payload.title
  },
  [types.SECOND_ID] (state, payload) {
    state.second_id = payload.second_id
  },
}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/mutations.js